import React from "react";
import { CoursesForm } from "../../components/Forms/CoursesForm/index";

const NewCourse = () => {
  return <CoursesForm></CoursesForm>;
};

export default NewCourse;
